import { createSlice } from "@reduxjs/toolkit";
import { welcomeEmailTemplateListAPI } from "../../services/welcomeEmailTemplateList";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const welcomeEmailTemplateListSlice = createSlice({
  name: "welcomeEmailTemplateList",
  initialState: data,
  reducers: {
    welcomeEmailTemplateInfo(state) {
      state.isLoading = true;
    },
    welcomeEmailTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
      state.statusCode = undefined;
    },
    welcomeEmailTemplateFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    welcomeEmailTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const welcomeEmailTemplateListHandler =
  (data, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(welcomeEmailTemplateAction.welcomeEmailTemplateInfo());
      const response = await welcomeEmailTemplateListAPI(data, requestOptions);
      dispatch(welcomeEmailTemplateAction.welcomeEmailTemplateSuccess(response));
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        welcomeEmailTemplateAction.welcomeEmailTemplateFailure(failurePayload),
      );
    }
  };

export default welcomeEmailTemplateListSlice.reducer;
export const welcomeEmailTemplateAction = welcomeEmailTemplateListSlice.actions;
